import React from 'react';
import { FileText, Zap, BookOpen, Shield, Lock, CreditCard, CheckCircle2, XCircle, Trophy, Target, Users, BarChart, Activity, Utensils, AlertTriangle, Calendar, RefreshCw, Brain, ChevronDown, Star, PlayCircle } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
import { CountdownTimer } from '../components/CountdownTimer';
import { BonusBook } from '../components/BonusBook';
import { PricingSelector } from '../components/PricingSelector';
import { trackFbEvent } from '../lib/fbPixel';
import { CHECKOUT_DEFAULT } from '../lib/checkout';
// Generic CTAs point to the most-chosen pack (Megapack Élite).
const CHECKOUT_URL = CHECKOUT_DEFAULT;
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-green-200" data-id="element-42">
      <PurchasePopup data-id="element-43" />

      {/* SECCIÓN 1 — HERO */}
      <header className="bg-slate-900 text-white pb-16 px-4 relative overflow-hidden" data-id="element-44">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-green-400 via-slate-900 to-slate-900" data-id="element-45"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-46">
          {/* ABOVE THE FOLD: fits in one iPhone viewport up to the CTA */}
          <div className="flex flex-col items-center justify-center min-h-[100svh] md:min-h-0 py-6 md:pt-16 md:pb-0" data-id="element-47">
            <div className="inline-block bg-green-500/20 border border-green-400/30 text-green-400 text-xs font-bold px-3 py-1 rounded-full mb-3 md:mb-6 tracking-wider uppercase" data-id="element-48">
              PROFE LISTO · FUTSAL 360
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold mb-3 md:mb-6 leading-tight tracking-tight" data-id="element-49">
              Todo tu año de futsal{' '}
              <span className="text-green-400" data-id="element-50">resuelto de una vez.</span>
            </h1>

            {/* Main Product Image */}
            <div className="w-full max-w-2xl mx-auto mb-3 md:mb-6 flex items-center justify-center min-h-0" data-id="element-51">
              <img src="https://cdn.magicpatterns.com/uploads/2G9JEfNWRL3Q7RbxTDiZAm/futsal_mock.png" alt="Megapack FUTSAL 360 — colección completa con 14 tomos, 6 bonus y 2 ebooks élite" width={1080} height={1350} fetchPriority="high" decoding="async" className="max-h-[34vh] sm:max-h-[40vh] md:max-h-none w-auto md:w-full h-auto object-contain drop-shadow-2xl" data-id="element-52" />
            </div>

            <h2 className="text-base sm:text-lg md:text-2xl text-slate-300 mb-4 md:mb-8 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-53">
              Megapack FUTSAL 360 — El sistema completo de clases y
              planificación para el entrenador de futsal argentino.
            </h2>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mb-5 md:mb-8 text-xs sm:text-sm font-medium text-slate-300" data-id="element-54">
              <div className="flex items-center gap-2" data-id="element-55">
                <FileText className="w-4 h-4 md:w-5 md:h-5 text-green-400" data-id="element-56" />{' '}
                PDF
              </div>
              <div className="flex items-center gap-2" data-id="element-57">
                <Zap className="w-4 h-4 md:w-5 md:h-5 text-green-400" data-id="element-58" /> Acceso
                Inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-59">
                <BookOpen className="w-4 h-4 md:w-5 md:h-5 text-green-400" data-id="element-60" /> 14
                Tomos + 6 Bonus + 2 Élite
              </div>
            </div>

            <a href={CHECKOUT_URL} onClick={() => trackFbEvent('Lead', {
            source: 'hero'
          })} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 md:py-5 text-lg md:text-xl font-bold text-slate-900 bg-green-400 hover:bg-green-300 rounded-full transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(74,222,128,0.3)]" data-id="element-61">
              💪 QUIERO MI FUTSAL 360 AHORA
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mt-8 text-xs text-slate-400" data-id="element-62">
            <div className="flex items-center gap-1" data-id="element-63">
              <Shield className="w-4 h-4" data-id="element-64" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-65">
              <Lock className="w-4 h-4" data-id="element-66" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-67">
              <CreditCard className="w-4 h-4" data-id="element-68" /> Tarjetas y transferencia
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-16 pt-10 border-t border-slate-800" data-id="element-69">
            <div data-id="element-70">
              <div className="text-3xl font-bold text-white" data-id="element-71">+300</div>
              <div className="text-sm text-slate-400" data-id="element-72">profes confían</div>
            </div>
            <div data-id="element-73">
              <div className="text-3xl font-bold text-white" data-id="element-74">14+6</div>
              <div className="text-sm text-slate-400" data-id="element-75">Tomos + Bonus</div>
            </div>
            <div data-id="element-76">
              <div className="text-3xl font-bold text-white" data-id="element-77">4.9/5</div>
              <div className="text-sm text-slate-400" data-id="element-78">calificación</div>
            </div>
            <div data-id="element-79">
              <div className="text-3xl font-bold text-white" data-id="element-80">🇦🇷</div>
              <div className="text-sm text-slate-400" data-id="element-81">Argentina</div>
            </div>
          </div>
        </div>
      </header>

      {/* SECCIÓN 2 — TESTIMONIOS INICIALES */}
      <section className="py-16 px-4 max-w-6xl mx-auto -mt-10 relative z-20" data-id="element-82">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-83">
          {[{
          initials: 'MP',
          name: 'Marcelo P.',
          city: 'Buenos Aires',
          role: 'Entrenador de Futsal en Club de Barrio',
          text: '"Organicé todo el mes en una tarde. Nunca más llego a la cancha sin saber qué clase dar."'
        }, {
          initials: 'CG',
          name: 'Carlos G.',
          city: 'Córdoba',
          role: 'Profe de Futsal en Academia Privada',
          text: '"Mis chicos de Infantiles mejoraron el sistema 2-2 desde la primera semana con el Tomo 3."'
        }, {
          initials: 'FR',
          name: 'Fabián R.',
          city: 'Rosario',
          role: 'Entrenador Independiente de Futsal',
          text: '"Antes tardaba 1 hora armando una clase. Ahora son 5 minutos."'
        }].map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100" data-id="element-84">
              <div className="flex items-center gap-3 mb-4" data-id="element-85">
                <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600" data-id="element-86">
                  {t.initials}
                </div>
                <div data-id="element-87">
                  <div className="font-bold text-sm flex items-center gap-1" data-id="element-88">
                    {t.name} 🇦🇷
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-89">{t.city}</div>
                </div>
              </div>
              <div className="flex items-center gap-1 text-yellow-400 mb-3" data-id="element-90">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-91" />)}
              </div>
              <p className="text-slate-700 italic mb-4 text-sm" data-id="element-92">"{t.text}"</p>
              <div className="text-xs font-medium text-slate-400" data-id="element-93">{t.role}</div>
            </div>)}
        </div>
      </section>

      {/* SECCIÓN 3 — DOLORES */}
      <section className="py-20 px-4 bg-white" data-id="element-94">
        <div className="max-w-3xl mx-auto" data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-96">
            Si sos profe de futsal, esto te va a sonar conocido:
          </h2>
          <div className="space-y-4 mb-12" data-id="element-97">
            {['Llegás a la cancha sin saber exactamente qué clase vas a dar', 'Tus jugadores no progresan porque no hay un orden claro de contenidos', 'Tenés grupos con edades mezcladas y no sabés cómo manejarlos', 'Repetís los mismos ejercicios sin darte cuenta y los chicos se aburren', 'Cuando falta un jugador clave perdés la continuidad de la clase', 'No podés justificar tu valor como profe porque no tenés nada sistematizado', 'Los padres te preguntan si los chicos mejoran y no tenés cómo demostrarlo', 'El domingo a la noche improvisás la clase del lunes con YouTube'].map((pain, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-red-50/50 border border-red-100" data-id="element-98">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-99" />
                <p className="text-slate-700 font-medium" data-id="element-100">{pain}</p>
              </div>)}
          </div>
          <div className="text-center" data-id="element-101">
            <h3 className="text-2xl md:text-3xl font-extrabold mb-8 text-slate-900" data-id="element-102">
              "¿Cuántas clases más vas a improvisar?"
            </h3>
            <a href={CHECKOUT_URL} onClick={() => trackFbEvent('Lead', {
            source: 'dolores'
          })} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-slate-900 hover:bg-slate-800 rounded-full transition-all" data-id="element-103">
              👉 BASTA DE IMPROVISAR — QUIERO MI FUTSAL 360
            </a>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — PRESENTACIÓN */}
      <section className="py-20 px-4 bg-slate-900 text-white text-center" data-id="element-104">
        <div className="max-w-4xl mx-auto" data-id="element-105">
          <div className="inline-flex items-center gap-2 bg-yellow-500/20 text-yellow-400 px-4 py-2 rounded-full font-bold text-sm mb-8 border border-yellow-500/30" data-id="element-106">
            <Trophy className="w-4 h-4" data-id="element-107" /> El Sistema N°1 para Entrenadores de
            Futsal Argentinos
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-108">
            FUTSAL 360 — Colección Completa
          </h2>
          <p className="text-xl md:text-2xl text-slate-300 mb-12 font-light" data-id="element-109">
            14 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todas las categorías.
          </p>
          <div className="flex flex-wrap justify-center gap-8 md:gap-16" data-id="element-110">
            <div className="text-center" data-id="element-111">
              <div className="text-4xl font-black text-green-400 mb-2" data-id="element-112">
                +270
              </div>
              <div className="text-slate-400 font-medium uppercase tracking-wider text-sm" data-id="element-113">
                páginas
              </div>
            </div>
            <div className="text-center" data-id="element-114">
              <div className="text-4xl font-black text-green-400 mb-2" data-id="element-115">
                +416
              </div>
              <div className="text-slate-400 font-medium uppercase tracking-wider text-sm" data-id="element-116">
                clases resueltas
              </div>
            </div>
            <div className="text-center" data-id="element-117">
              <div className="text-4xl font-black text-green-400 mb-2" data-id="element-118">
                Todas
              </div>
              <div className="text-slate-400 font-medium uppercase tracking-wider text-sm" data-id="element-119">
                las categorías
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5 — LOS 14 TOMOS */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-120">
        <div className="max-w-6xl mx-auto" data-id="element-121">
          <div className="text-center mb-16" data-id="element-122">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-123">
              Los 14 Tomos Completos
            </h2>
            <p className="text-xl text-slate-600" data-id="element-124">
              Clases resueltas · Por categoría y nivel · Listo para usar mañana
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-125">
            {[{
            title: 'Minis — Semestre 1',
            age: '5 a 7 años',
            desc: 'El primer contacto con la pelota. Lateralidad, freno y relación básica con el balón en 26 clases completas.'
          }, {
            title: 'Minis — Semestre 2',
            age: '5 a 7 años',
            desc: 'Consolidación del año de Minis. Pase inicial, orientación espacial y primer juego colectivo real.'
          }, {
            title: 'Infantiles — Semestre 1',
            age: '8 a 10 años',
            desc: 'Primer toque orientado, cabeza levantada y sistema 2-2 básico.'
          }, {
            title: 'Infantiles — Semestre 2',
            age: '8 a 10 años',
            desc: 'Cierres y Alas definidos. Marcaje individual y pie no dominante.'
          }, {
            title: 'Menores — Semestre 1',
            age: '11 a 13 años',
            desc: 'Sistema 3-1 base y pressing coordinado en bloque.'
          }, {
            title: 'Menores — Semestre 2',
            age: '11 a 13 años',
            desc: 'Variantes ofensivas, balón parado y consolidación del sistema.'
          }, {
            title: 'Cadetes — Semestre 1',
            age: '14 a 15 años',
            desc: 'Rotaciones avanzadas, lectura táctica y comunicación en cancha.'
          }, {
            title: 'Cadetes — Semestre 2',
            age: '14 a 15 años',
            desc: 'Sistemas complejos, definición especializada y preparación mental.'
          }, {
            title: 'Juveniles — Semestre 1',
            age: '16 a 17 años',
            desc: '4-0 de alta rotación, pressing ultra-alto y análisis del rival.'
          }, {
            title: 'Juveniles — Semestre 2',
            age: '16 a 17 años',
            desc: 'Plan de partido, gestión del marcador y torneo de cierre.'
          }, {
            title: 'Adultos Iniciales',
            age: '52 clases',
            desc: 'Técnica base, sistema 2-2 y primer partido real.'
          }, {
            title: 'Adultos Intermedios',
            age: '52 clases',
            desc: 'Sistema 3-1, pressing coordinado y análisis táctico básico.'
          }, {
            title: 'Adultos Avanzados',
            age: '52 clases',
            desc: 'Sistemas Pro, preparación mental competitiva y especialización por posición.'
          }, {
            title: 'Casos Especiales',
            age: 'Manual',
            desc: 'Físico, lesiones, emergencias y preparación de torneo completa.'
          }].map((tomo, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 hover:border-green-400 transition-colors" data-id="element-126">
                <div className="text-xs font-bold text-green-600 mb-2 uppercase tracking-wider" data-id="element-127">
                  TOMO {i + 1}
                </div>
                <h3 className="text-lg font-bold mb-1" data-id="element-128">{tomo.title}</h3>
                <div className="text-sm text-slate-500 mb-3 font-medium" data-id="element-129">
                  {tomo.age}
                </div>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-130">
                  {tomo.desc}
                </p>
              </div>)}
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm font-bold text-slate-700 bg-white p-6 rounded-2xl shadow-sm border border-slate-200" data-id="element-131">
            <div className="flex items-center gap-2" data-id="element-132">
              <FileText className="w-5 h-5 text-green-500" data-id="element-133" /> Clases resueltas
              en cada tomo
            </div>
            <div className="flex items-center gap-2" data-id="element-134">
              <Zap className="w-5 h-5 text-green-500" data-id="element-135" /> Sistema "Abrí y
              Entrenás"
            </div>
            <div className="flex items-center gap-2" data-id="element-136">
              <FileText className="w-5 h-5 text-green-500" data-id="element-137" /> Planillas listas
              para imprimir
            </div>
            <div className="flex items-center gap-2" data-id="element-138">
              <Target className="w-5 h-5 text-green-500" data-id="element-139" /> Contenido 100% para
              Argentina
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — LOS 6 BONUS */}
      <section className="py-20 px-4 bg-white" data-id="element-140">
        <div className="max-w-6xl mx-auto" data-id="element-141">
          <div className="text-center mb-16" data-id="element-142">
            <div className="inline-block bg-red-100 text-red-600 font-black px-4 py-1.5 rounded-full mb-4 text-sm tracking-wide" data-id="element-143">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-144">
              + 6 Regalos Estratégicos Incluidos
            </h2>
            <p className="text-xl text-slate-600" data-id="element-145">
              Sin costo extra · Valor real del pack: $54.000
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-146">
            {[{
            icon: BarChart,
            accent: 'text-green-400',
            title: 'Nivelómetro 360',
            desc: 'Tests de campo, grillas por categoría y reporte mensual para padres y club. Medí el progreso real de tus jugadores.'
          }, {
            icon: Activity,
            accent: 'text-orange-400',
            title: 'Físico Express',
            desc: 'Circuitos de potencia y resistencia específica para futsal sin gimnasio. Adaptado por edad y categoría.'
          }, {
            icon: Utensils,
            accent: 'text-lime-400',
            title: 'Nutrición y Rendimiento',
            desc: 'Qué comer antes del entrenamiento, el día del partido y cómo recuperarse. Guía lista para compartir con padres.'
          }, {
            icon: AlertTriangle,
            accent: 'text-red-400',
            title: 'Clases de Emergencia',
            desc: '10 clases resueltas para cuando llovió, vino la mitad del grupo o no tenés cancha disponible.'
          }, {
            icon: Users,
            accent: 'text-sky-400',
            title: 'Kit de Supervivencia Infantil',
            desc: '20 juegos para mantener el foco de los chicos de 5 a 10 años. Gestión de conflictos y rutinas de clase.'
          }, {
            icon: Calendar,
            accent: 'text-yellow-400',
            title: 'Pack de Organización Semanal',
            desc: 'Planificá tu semana completa en 15 minutos. Plantillas, mapa anual y registro de asistencia incluidos.'
          }].map((bonus, i) => <div key={i} className="bg-white rounded-3xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center px-6 pt-8 pb-8" data-id="element-147">
                <BonusBook icon={bonus.icon} number={i + 1} accent={bonus.accent} data-id="element-148" />

                <div className="inline-block bg-green-100 text-green-700 text-xs font-black px-4 py-1.5 rounded-full mt-6 mb-4 tracking-wide" data-id="element-149">
                  GRATIS
                </div>

                <h3 className="text-lg font-bold mb-3 text-slate-900 flex items-center justify-center gap-2" data-id="element-150">
                  <bonus.icon className={`w-5 h-5 ${bonus.accent.replace('400', '500')}`} data-id="element-151" />
                  Bonus {i + 1} — {bonus.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-152">
                  {bonus.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 7 — PRECIO Y CTA */}
      <section className="py-20 px-4 bg-slate-900 text-white relative" id="pricing" data-id="element-153">
        <div className="max-w-5xl mx-auto" data-id="element-154">
          <div className="text-center mb-12" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-yellow-400" data-id="element-156">
              ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
            </h2>
            <div className="inline-flex flex-col items-center bg-slate-800 p-4 rounded-xl border border-slate-700" data-id="element-157">
              <CountdownTimer data-id="element-158" />
              <div className="text-red-400 text-sm font-medium flex items-center gap-2" data-id="element-159">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-160"></span>
                El precio sube cuando termina el contador
              </div>
            </div>
            <p className="text-xl mt-8 text-slate-300" data-id="element-161">
              Elegí tu Pack: Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          <PricingSelector data-id="element-162" />

          <div className="flex flex-wrap justify-center gap-8 mt-12 text-sm font-medium text-slate-400" data-id="element-163">
            <div className="flex items-center gap-2" data-id="element-164">
              <Lock className="w-4 h-4" data-id="element-165" /> Pago seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-166">
              <Zap className="w-4 h-4" data-id="element-167" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-2" data-id="element-168">
              <Shield className="w-4 h-4" data-id="element-169" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-2" data-id="element-170">
              <CreditCard className="w-4 h-4" data-id="element-171" /> Tarjeta · Transferencia
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 8 — QUÉ AGREGA EL ÉLITE */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <div className="text-center mb-12" data-id="element-174">
            <h2 className="text-3xl font-bold mb-4" data-id="element-175">
              ¿Qué agrega el Megapack Élite?
            </h2>
            <p className="text-xl text-slate-600" data-id="element-176">
              Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-177">
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-178">
              <RefreshCw className="w-10 h-10 text-green-500 mb-4" data-id="element-179" />
              <h3 className="text-xl font-bold mb-3" data-id="element-180">
                Élite 1 — El Generador Infinito
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-181">
                100 variaciones dinámicas para que tus entrenamientos nunca se
                repitan. Un solo ejercicio se convierte en 10. No improvises más
                cuando el grupo dice "esto ya lo hicimos."
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-182">
              <Brain className="w-10 h-10 text-green-500 mb-4" data-id="element-183" />
              <h3 className="text-xl font-bold mb-3" data-id="element-184">
                Élite 2 — Pizarra Maestra
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-185">
                El ajedrez del DT de futsal. Salidas Pro, jugadas de balón
                parado, gestión del marcador y scouting del rival en 5 minutos.
                Ganá los partidos que antes no sabías cómo ganar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 9 — TABLA DE COMPARACIÓN */}
      <section className="py-20 px-4 bg-white" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-188">
            ¿Cuánto cuesta NO tenerlo?
          </h2>

          <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm mb-12" data-id="element-189">
            <table className="w-full text-left border-collapse" data-id="element-190">
              <thead data-id="element-191">
                <tr data-id="element-192">
                  <th className="p-4 md:p-6 bg-slate-50 border-b border-slate-200 font-bold text-slate-500 w-1/3" data-id="element-193"></th>
                  <th className="p-4 md:p-6 bg-red-50 border-b border-red-100 font-bold text-red-700 text-center w-1/3" data-id="element-194">
                    SIN FUTSAL 360
                  </th>
                  <th className="p-4 md:p-6 bg-green-50 border-b border-green-100 font-bold text-green-700 text-center w-1/3" data-id="element-195">
                    CON FUTSAL 360
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm md:text-base" data-id="element-196">
                {[['Horas planificando', 'Toda la semana.', '5 minutos. Todo listo.'], ['Clases', 'Improvisadas sin progresión', '416 clases resueltas'], ['Grupos de distintas edades', 'Sin sistema claro', 'Estructura por categoría'], ['Los chicos se aburren', '"Profe, esto ya lo hicimos"', 'Variaciones infinitas'], ['Falta la mitad del grupo', 'La clase se cae', '10 clases de emergencia'], ['Padres que preguntan', 'No tenés respuesta', 'Reporte mensual listo'], ['El sábado de partido', 'Nerviosa/o en el banco', 'Plan de partido en la mano'], ['El domingo a la noche', 'Ansiedad y YouTube', 'Semana resuelta en 15 minutos']].map((row, i) => <tr key={i} className="border-b border-slate-100 last:border-0" data-id="element-197">
                    <td className="p-4 md:p-6 font-medium text-slate-700" data-id="element-198">
                      {row[0]}
                    </td>
                    <td className="p-4 md:p-6 text-center text-red-600 bg-red-50/30" data-id="element-199">
                      {row[1]}
                    </td>
                    <td className="p-4 md:p-6 text-center text-green-700 font-bold bg-green-50/30" data-id="element-200">
                      {row[2]}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center" data-id="element-201">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-slate-900" data-id="element-202">
              El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
            </h3>
            {/* BOTÓN PERSUASIVO EXTRA */}
            <a href={CHECKOUT_URL} onClick={() => trackFbEvent('Lead', {
            source: 'comparativa'
          })} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-green-600 hover:bg-green-500 rounded-full transition-all shadow-lg shadow-green-600/30 animate-bounce" data-id="element-203">
              QUIERO ENTRAR CON TODO RESUELTO ESTE LUNES
            </a>
          </div>
        </div>
      </section>

      {/* SECCIÓN 10 — TESTIMONIOS COMPLETOS */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-204">
        <div className="max-w-6xl mx-auto" data-id="element-205">
          <div className="text-center mb-12" data-id="element-206">
            <h2 className="text-3xl font-bold mb-2" data-id="element-207">
              Lo que dicen los entrenadores
            </h2>
            <div className="flex items-center justify-center gap-1 text-yellow-400 text-xl font-bold" data-id="element-208">
              4.9/5 <Star className="fill-current w-6 h-6" data-id="element-209" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-210">
            {[{
            initials: 'MP',
            name: 'Marcelo P.',
            city: 'Buenos Aires',
            text: '"Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso."'
          }, {
            initials: 'CG',
            name: 'Carlos G.',
            city: 'Córdoba',
            text: '"Mis chicos de Infantiles que estaban estancados mejoraron el sistema 2-2 en el primer mes con el Tomo 3."'
          }, {
            initials: 'FR',
            name: 'Fabián R.',
            city: 'Rosario',
            text: '"Antes tardaba 1 hora armando una clase. Ahora son 5 minutos. Y las clases son mejores."'
          }, {
            initials: 'SV',
            name: 'Santiago V.',
            city: 'Mendoza',
            text: '"El Bonus del Nivelómetro cambió cómo evalúo a mis jugadores. Ahora tengo datos para mostrar a los padres. Me gané el respeto."'
          }, {
            initials: 'DA',
            name: 'Diego A.',
            city: 'Santa Fe',
            text: '"La Pizarra Maestra me salvó en la final del torneo. Supe exactamente qué cambiar en el entretiempo. Ganamos."'
          }, {
            initials: 'CR',
            name: 'Cecilia R.',
            city: 'Tucumán',
            text: '"El Generador Infinito cambió mis clases. Los chicos ya no dicen \'esto ya lo hicimos\'. Siempre hay algo nuevo."'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100" data-id="element-211">
                <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-212">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-213" />)}
                </div>
                <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-214">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-215">
                  <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600 text-sm" data-id="element-216">
                    {t.initials}
                  </div>
                  <div data-id="element-217">
                    <div className="font-bold text-sm flex items-center gap-1" data-id="element-218">
                      {t.name} 🇦🇷
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-219">{t.city}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 11 — GARANTÍA */}
      <section className="py-20 px-4 bg-slate-900 text-white text-center" data-id="element-220">
        <div className="max-w-2xl mx-auto" data-id="element-221">
          <Shield className="w-20 h-20 text-green-400 mx-auto mb-6" data-id="element-222" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-223">
            Garantía 7 días sin preguntas
          </h2>
          <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-224">
            Abrí los 14 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            clase.
            <br data-id="element-225" />
            <br data-id="element-226" />
            Si no es lo que esperabas → 100% de devolución. Sin preguntas. Sin
            formularios. Sin drama.
          </p>
          <div className="inline-block bg-slate-800 text-slate-300 font-bold px-6 py-2 rounded-full border border-slate-700 text-sm tracking-wider" data-id="element-227">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </section>

      {/* SECCIÓN 12 — FAQ */}
      <section className="py-20 px-4 bg-white" data-id="element-228">
        <div className="max-w-3xl mx-auto" data-id="element-229">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-230">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-231">
            {[{
            q: '¿Cómo recibo el material?',
            a: 'Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. Podés descargarlos en tu celu, tablet o computadora. Es tuyo de por vida.'
          }, {
            q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
            a: 'Los dos. Si empezás: tenés un sistema completo desde el primer día sin improvisar. Si ya tenés experiencia: organizás y profesionalizás lo que ya sabés hacer.'
          }, {
            q: '¿Los 6 Bonus están en las dos opciones?',
            a: 'Sí. Los 6 Bonus estratégicos están incluidos tanto en el Pack Profesional como en el Megapack Élite.'
          }, {
            q: '¿Qué diferencia hay con otros materiales de futsal que existen?',
            a: 'FUTSAL 360 es el único sistema en Argentina con 14 tomos progresivos que cubren desde Minis (5 años) hasta Adultos Avanzados en un solo bundle. No son ejercicios sueltos. Es un año completo resuelto por categoría.'
          }, {
            q: '¿Sirve para categorías mezcladas en el mismo grupo?',
            a: 'Sí. El Bonus 4 (Clases de Emergencia) tiene una sección específica para grupos mixtos de distintas edades y niveles.'
          }, {
            q: '¿Qué pasa si no me sirve?',
            a: 'Tenés 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% sin preguntas ni formularios.'
          }, {
            q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
            a: 'Si ya planifico bien: el Generador Infinito te da variaciones infinitas para que tus clases nunca se repitan. La Pizarra Maestra te da las respuestas tácticas para los partidos difíciles. Por $9.000 más: es la diferencia entre un buen profe y un DT de élite.'
          }, {
            q: '¿Puedo pagar con tarjeta de crédito?',
            a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago. El acceso es inmediato después del pago.'
          }].map((faq, i) => <details key={i} className="group bg-slate-50 rounded-xl border border-slate-200 [&_summary::-webkit-details-marker]:hidden" data-id="element-232">
                <summary className="flex items-center justify-between p-6 cursor-pointer font-bold text-slate-900" data-id="element-233">
                  {faq.q}
                  <ChevronDown className="w-5 h-5 text-slate-400 group-open:rotate-180 transition-transform" data-id="element-234" />
                </summary>
                <div className="px-6 pb-6 text-slate-600 leading-relaxed" data-id="element-235">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 13 — CTA FINAL */}
      <section className="py-24 px-4 bg-green-500 text-slate-900 text-center relative overflow-hidden" data-id="element-236">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-237"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-238">
          <PlayCircle className="w-20 h-20 mx-auto mb-8 opacity-80" data-id="element-239" />
          <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-240">
            FUTSAL 360 — El sistema de planificación N°1 para entrenadores de
            futsal argentinos.
          </h2>
          <p className="text-2xl mb-12 font-medium opacity-90" data-id="element-241">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>
          <a href={CHECKOUT_URL} onClick={() => trackFbEvent('Lead', {
          source: 'cta_final'
        })} className="inline-flex items-center justify-center px-10 py-6 text-2xl font-black text-white bg-slate-900 hover:bg-slate-800 rounded-full transition-all transform hover:scale-105 shadow-2xl" data-id="element-242">
            💪 QUIERO MI FUTSAL 360 AHORA
          </a>
        </div>
      </section>

      {/* SECCIÓN 14 — FOOTER */}
      <footer className="bg-slate-950 text-slate-400 py-12 px-4 text-center text-sm" data-id="element-243">
        <div className="max-w-4xl mx-auto" data-id="element-244">
          <div className="font-bold text-white text-xl mb-6 flex items-center justify-center gap-2" data-id="element-245">
            ⚽ FUTSAL 360™
          </div>
          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-246">
            <a href="#" className="hover:text-white transition-colors" data-id="element-247">
              📧 contacto@futsal360.com.ar
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-248">
              📲 @futsal360.ar
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-249">
              🌐 www.futsal360.ar
            </a>
          </div>
          <p data-id="element-250">
            © FUTSAL 360™ {new Date().getFullYear()} — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
        </div>
      </footer>
    </div>;
}